/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Qc_Fix_Fit_One_LineInputs */



/**
* | output |
* | --- |
* | "Fit text on one line" |
*
* @param {Qc_Fix_Fit_One_LineInputs} inputs
* @param {{ locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }} options
* @returns {LocalizedString}
*/
export const qc_fix_fit_one_line = /** @type {((inputs?: Qc_Fix_Fit_One_LineInputs, options?: { locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Qc_Fix_Fit_One_LineInputs, { locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }, {}>} */ ((inputs = {}, options = {}) => {
	void inputs;
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "fr") return /** @type {LocalizedString} */ ("Ajuster le texte sur une ligne")
	if (locale === "de") return /** @type {LocalizedString} */ ("Text auf eine Zeile anpassen")
	if (locale === "it") return /** @type {LocalizedString} */ ("Adatta il testo su una riga")
	if (locale === "ru") return /** @type {LocalizedString} */ ("Уместить текст в одну строку")
	if (locale === "es") return /** @type {LocalizedString} */ ("Ajustar el texto a una línea")
	if (locale === "zh-CN") return /** @type {LocalizedString} */ ("将文本放入一行")
	if (locale === "ja") return /** @type {LocalizedString} */ ("テキストを1行に収める")
	if (locale === "hi") return /** @type {LocalizedString} */ ("टेक्स्ट को एक पंक्ति में समायोजित करें")
	if (locale === "pt-PT") return /** @type {LocalizedString} */ ("Ajustar o texto a uma linha")
	return /** @type {LocalizedString} */ ("Fit text on one line")
});